export const EventNames = {
  BASE_VERIFICATION_STATUS_CHANGED: 'app.base_verification.status.changed',
  BURGER_MENU_TOGGLE: 'app.burger_menu.toggle',
} as const;

export type EventName = typeof EventNames[keyof typeof EventNames];
